import { forwardRef } from 'react';
import cx from 'classnames';
import {
  AppBar,
  Backdrop,
  Hidden,
  LinearProgress,
  Toolbar,
  makeStyles,
} from '@material-ui/core';
import { useSelector } from 'react-redux';

export const height = {
  desktop: 64,
  mobile: 68,
};

const useStyles = makeStyles((theme) => ({
  header: {
    backgroundColor: 'transparent',
    minHeight: height.desktop,

    [theme.breakpoints.down('xs')]: {
      minHeight: height.mobile,
    },
  },
  headerContainer: {
    borderBottom: ({ border }) => {
      if (!border) {
        return '0px solid transparent';
      }
      return `2px solid ${theme.palette.primary.main}`;
    },
    backgroundColor: '#fff',
    boxShadow: '0px 0px 16px rgba(16, 16, 16, 0.16)',

    [theme.breakpoints.down('xs')]: {
      boxShadow: '0px 4px 8px rgba(64, 62, 41, 0.18)',
      backgroundColor: theme.palette.colors.grey100,
      borderBottom: 'none',
      paddingTop: ({ isloggedIn }) => (isloggedIn ? 6 : 0),
      paddingBottom: ({ isloggedIn }) => (isloggedIn ? 6 : 0),

      '& > *': {
        transform: ({ isloggedIn }) =>
          isloggedIn ? 'none' : 'translateY(5px)',
      },
    },
  },
  toolbar: {
    minHeight: height.desktop,

    [theme.breakpoints.down('xs')]: {
      justifyContent: 'space-between',
      minHeight: height.mobile,
    },
  },
  gutters: ({ nopadding }) => ({
    padding: nopadding ? 0 : theme.spacing(0, 8),

    [theme.breakpoints.down('xs')]: {
      padding: nopadding ? 0 : theme.spacing(0, 3),
    },
  }),
  backdrop: {
    top: height.desktop,

    [theme.breakpoints.down('xs')]: {
      top: height.mobile,
    },
  },
  progress: {
    width: '100%',
    position: 'absolute',
    top: -3,
  },
  subheader: {
    color: 'initial',
    boxShadow: '0px 4px 8px rgba(64, 62, 41, 0.18)',
    backgroundColor: theme.palette.colors.grey100,
    padding: theme.spacing(1, 8),
    minHeight: 64,
    display: 'flex',

    [theme.breakpoints.down('xs')]: {
      backgroundColor: 'transparent',
      padding: theme.spacing(0, 3, 1, 3),
      boxShadow: 'none',
    },
  },
}));

const MainHeader = forwardRef((props, ref) => {
  const {
    children,
    className,
    border = true,
    loading,
    subheader,
    nopadding,
  } = props;

  const isloggedIn = useSelector((state) => state.authorization.isloggedIn);

  const classes = useStyles({ border, nopadding, isloggedIn });

  return (
    <AppBar
      ref={ref}
      position="fixed"
      elevation={0}
      className={cx(classes.header, className)}
    >
      <div className={classes.headerContainer}>
        <Toolbar
          classes={{
            root: classes.toolbar,
            gutters: classes.gutters,
          }}
        >
          {children}
        </Toolbar>

        {subheader && (
          <Hidden smUp>
            <div className={classes.subheader}>{subheader}</div>
          </Hidden>
        )}
      </div>

      {subheader && (
        <Hidden xsDown>
          <div className={classes.subheader}>{subheader}</div>
        </Hidden>
      )}

      <Backdrop open={!!loading} className={classes.backdrop}>
        <LinearProgress className={classes.progress} />
      </Backdrop>
    </AppBar>
  );
});

export default MainHeader;
